export function deleteItemsFromObj<T extends Record<string, any>>(
  obj: T,
  ...keys: (keyof T)[]
): Omit<T, typeof keys[number]> {
  const copy = { ...obj };
  
  for (const k of keys) delete copy[k];
  return copy as Omit<T, typeof keys[number]>;
};